import React from 'react';
import { Link } from 'react-router-dom';
import { categoryLabel } from '../data/categories';
import { categoryTone } from '../data/tones';
import { IconLeaf } from './Icons';

export default function PlantCard({ plant }) {
  const thumbnail = plant.photos?.[0]?.thumbnailUrl || plant.photos?.[0]?.url;

  return (
    <Link to={`/plant/${plant.plantId}`} className={`plant-card ${categoryTone(plant.category)}`}>
      <div className="plant-card__media">
        {thumbnail
          ? <img src={thumbnail} alt={plant.plantName} loading="lazy" />
          : <IconLeaf size={36} />}
      </div>
      <div className="plant-card__body">
        <h3 className="plant-card__name">{plant.plantName}</h3>
        {plant.scientificName && (
          <p className="plant-card__sci">{plant.scientificName}</p>
        )}
        <span className="tag">{categoryLabel(plant.category)}</span>
      </div>
    </Link>
  );
}
